import React, { useState } from 'react';
import user from '../../Mobx/User';
import { observer } from 'mobx-react';
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Drawer, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import UserNameDisplay from '../User/UserNameDisplay';
import Logout from '../User/Logout';
import NoToolsMessage from './NoToolsMessage';
import './Layout.css';

const Layout = observer(({ children, tools, drawerTools, toolsConfig = {} }) => {
    const {
        toolsHeight,
        toolsBackgroundColor,
        drawerToolsWidth
    } = toolsConfig;

    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation(); // לקבל את המיקום הנוכחי

    if (!drawerTools || drawerTools.length === 0) {
        drawerTools = [<NoToolsMessage />];
    }

    const toggleDrawer = () => {
        setDrawerOpen(!isDrawerOpen);
    };

    const isActive = (path) => location?.pathname === path; // פונקציה שבודקת אם ה-URL תואם

    return (
        <div className="Layout">
            <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", dir: "rtl" }}>
                {/* פס ניווט */}
                <AppBar position="static" elevation={0} sx={{
                    height: 50,
                    justifyContent: "center", // מרכז את הכלים בציר האופקי
                    // alignItems: "center", // מרכז את הכלים בציר האנכי
                }}>
                    <Toolbar disableGutters sx={{ padding: 1 }}>
                        {/* אייקון תפריט בצד ימין */}
                        <IconButton color="inherit" onClick={toggleDrawer}>
                            <MenuIcon />
                        </IconButton>

                        {/* שם האתר */}
                        <Typography
                            variant="body2"
                            component={Link}
                            to="/home"
                            sx={{
                                ml: 1,
                                p: 0.5,
                                textDecoration: 'none',
                                color: 'inherit',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                            }}
                        >
                            Lexillon Admin
                        </Typography>

                        {/* כפתורים במרכז */}
                        {user.limitedAdmin.includes(user.email) ?
                            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    className={`nav-button ${isActive('/ai') ? 'active' : ''}`}
                                    component={Link}
                                    to="/ai"
                                >
                                    AI
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/images') ? 'active' : ''}`}
                                    component={Link}
                                    to="/images"
                                >
                                    תמונות
                                </Button>
                            </Box>
                            :
                            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    className={`nav-button ${isActive('/dictionary') ? 'active' : ''}`}
                                    component={Link}
                                    to="/dictionary"
                                >
                                    מילונים
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/ai') ? 'active' : ''}`}
                                    component={Link}
                                    to="/ai"
                                >
                                    AI
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/tests') ? 'active' : ''}`}
                                    component={Link}
                                    to="/tests"
                                >
                                    בדיקות
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/images') ? 'active' : ''}`}
                                    component={Link}
                                    to="/images"
                                >
                                    תמונות
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/categories') ? 'active' : ''}`}
                                    component={Link}
                                    to="/categories"
                                >
                                    קטגוריות
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/search') ? 'active' : ''}`}
                                    component={Link}
                                    to="/search"
                                >
                                    חיפוש
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/audio') ? 'active' : ''}`}
                                    component={Link}
                                    to="/audio"
                                >
                                    אודיו
                                </Button>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ mx: 2, borderColor: 'grey.400' }}
                                />
                                <Button
                                    className={`nav-button ${isActive('/customers') ? 'active' : ''}`}
                                    component={Link}
                                    to="/customers"
                                >
                                    משתמשים
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/classroom') ? 'active' : ''}`}
                                    component={Link}
                                    to="/classroom"
                                >
                                    כיתות
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/access-serial') ? 'active' : ''}`}
                                    component={Link}
                                    to="/access-serial"
                                >
                                    סיריאלים
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/profiles') ? 'active' : ''}`}
                                    component={Link}
                                    to="/profiles"
                                >
                                    פרופילים
                                </Button>
                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ mx: 2, borderColor: 'grey.400' }}
                                />
                                <Button
                                    className={`nav-button ${isActive('/statistics') ? 'active' : ''}`}
                                    component={Link}
                                    to="/statistics"
                                >
                                    סטטיסטיקות
                                </Button>
                                <Button
                                    className={`nav-button ${isActive('/test-paypal') ? 'active' : ''}`}
                                    component={Link}
                                    to="/test-paypal"
                                    sx={{ textTransform: 'none' }}
                                >
                                    PayPal
                                </Button>
                            </Box>
                        }
                        {/* כפתור יציאה ושם משתמש בצד שמאל */}
                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
                            <UserNameDisplay />
                            <Logout />
                        </Box>
                    </Toolbar>
                </AppBar>

                {/* פס כלים שימושיים */}
                {tools.length > 0 &&
                    <Box
                        sx={{
                            bgcolor: toolsBackgroundColor || "primary.light",
                            height: toolsHeight || 50,
                            p: 1,
                            display: "flex",
                            gap: 2,
                            justifyContent: "center", // מרכז את הכלים בציר האופקי
                            alignItems: "center", // מרכז את הכלים בציר האנכי
                        }}
                    >
                        {tools.map((tool, index) => (
                            <React.Fragment key={index}>
                                {tool}
                            </React.Fragment>
                        ))}
                    </Box>
                }
                {/* גוף הדף */}
                <Box sx={{ flexGrow: 1, p: 0 }}>{children}</Box>

                {/* חלונית נפתחת מצד ימין */}
                <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer}>
                    <Box className="rtl-scroll" sx={{ width: drawerToolsWidth || 310, px: 1, py: 2 }}>
                        {/* <Typography variant="h6">כלים נוספים</Typography> */}
                        {drawerTools.map((tool, index) => (
                            <React.Fragment key={index}>
                                {tool}
                                {index < drawerTools.length - 1 && (
                                    <Divider
                                        sx={{
                                            my: 3, // רווחים מעל ומתחת
                                            borderColor: 'primary.main', // צבע ראשי
                                            borderWidth: 4, // עובי הקו
                                            // borderStyle: 'dashed', // סגנון הקו (אפשר solid, dashed, וכו')
                                        }}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </Box>
                </Drawer>
            </Box>
        </div>
    );
});

export default Layout;
